import {
  Component,
  OnInit,
  AfterViewInit,
  AfterContentChecked,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Inject,
  Renderer2,
  PLATFORM_ID
} from '@angular/core';
import { SvcServices, PopupModalService, ContentService, HoneyPotService, windowService } from '../services';
/**commented below code to stop sitecatlsyt code to execute, for this we added adobe launch */
 import { SiteCatalystService } from 'app/services';
 import { SiteCatalystPageData } from 'app/models';
import { environment } from '../../environments/environment';
import { ActivatedRoute } from '@angular/router';


import { Router, RouterStateSnapshot } from '@angular/router';
import { Location, isPlatformBrowser } from '@angular/common';
import { DmarService } from 'app/services/dmar.service';

import { SignOnFormComponent } from 'app/signon/sign-on-form/sign-on-form.component';
import { PrimaryBannerComponent } from 'app/signon/primary-banner/primary-banner.component';
import { SecondaryBannerComponent } from 'app/signon/secondary-banner/secondary-banner.component';
import { FlexBannerComponent } from 'app/signon/flex-banner/flex-banner.component';
import { SignOnHeaderComponent } from 'app/signon/sign-on-header/sign-on-header.component';
import { AppConfigService } from '@citi-gcg-173875/citi-utils';
// import { AppConfigService } from '@citi-gcg-169073/ccp-uiux-angular/services';
import { HostListener } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CrsUnsubscriberComponent } from './crs-unsubscriber.component';
import { takeUntil, filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { GuidService } from 'app/services/guid.service';

@Component({
  selector: 'signon-layout',
  templateUrl: './signon-layout.component.html'
})
export class SignonLayoutComponent extends CrsUnsubscriberComponent implements OnInit {

  // @ViewChild('marquee', { read: ViewContainerRef }) marqueePglt: ViewContainerRef;
  // @ViewChild('main', { read: ViewContainerRef }) mainPglt: ViewContainerRef;
  // @ViewChild('utility', { read: ViewContainerRef }) utilityPglt: ViewContainerRef;

  globalData: any;
  isLoaded: boolean = false;
  moduleContent: any;
  isChannelFusion: any;
  errormessage: string = "";
  scPageData: SiteCatalystPageData;
  urlParameters: any;
  siteId: any;
  businessId: any;
  XXXExtra: any;
  lastScrollTop: any;
  branding: any;
  ifBookmarkEnabled: any;
  isPrimaryContentDiffFromFlexSeo: boolean;
  adBlockerEnabled: any;
  isKnownUser: boolean = false;
  scrollLock: boolean = true;
  brandId:string;
  isWayfair:  boolean = false;
  config: any;
  api: any;
  endpointMap: any;
  channel: any;
  endpoints: Map<string, string>;
  isSignonFlexSeoDisable: boolean=false;

  constructor(
    private _svcService: SvcServices,
    private _contentService: ContentService,
    private location: Location,
    private meta: Meta,
    private title: Title,
    private router: Router,
    private route: ActivatedRoute,
    private dmar: DmarService,
    private scService: SiteCatalystService,
    private _appConfigService: AppConfigService,
    private _renderer: Renderer2,
    private popupModalService: PopupModalService,
    private _hpTokenService: HoneyPotService,
    private _svcServices: SvcServices,
    public windowService: windowService,
    private _http: HttpClient,
    private guidService: GuidService,
    @Inject(PLATFORM_ID) private platformId: string
  ) { 
    super();
    this.setConfig();
  }
  
  setConfig() {
    this.config = this._appConfigService.getConfig("api");
    // api = this.config;
    this.endpointMap =
      Object
        .keys(this.config?.endpoints)
        .reduce((map, endpoint, i) => {
          map[i] = [endpoint, this.config?.endpoints[endpoint]];
          return map;
        }, []);
    this.channel = this.config?.channel;
    this.endpoints = new Map(this.endpointMap);
  }

  isHidden: boolean = false;
  // config = this._appConfigService.getConfig("api");
  // api = this.config;
  // endpointMap =
  //   Object
  //     .keys(this.api.endpoints)
  //     .reduce((map, endpoint, i) => {
  //       map[i] = [endpoint, this.api.endpoints[endpoint]];
  //       return map;
  //     }, []);
  // public endpoints: Map<string, string> = new Map(this.endpointMap); 
  public uuidValue: any;

  ngOnInit() {    
    this.urlParameters = this._contentService.getParams();
    console.log(" this.urlParameters",  this.urlParameters);
    if (this.urlParameters) {
      if(!this.urlParameters.brandId) {
        this.brandId='WF';
      } else {
        this.brandId=this.urlParameters.brandId.toUpperCase();
      } 
    }
    if (isPlatformBrowser(this.platformId)) {
      this.lastScrollTop = this.windowService.nativeWindow.pageYOffset || this.windowService.nativeWindow.document.documentElement.scrollTop;
    }
    //console.log(this.urlParameters);
    this.siteId = this.urlParameters.siteId;
    console.log("this.siteId",this.siteId);
    if (this.siteId?.toUpperCase() == "PLCN_BESTBUY"){
        sessionStorage.setItem('bby_previous_page', "sign_on");
    }
    let environment = this._appConfigService.getConfig("businessIDMapping")[0];
    for (let key in environment) {
      if (this.siteId == key) {
        this.businessId = environment[key];
      }
    }
   // this.adBlockerEnabled = this.dmar.isAdBlockerEnabled();
   if(this.dmar.isAdBlocking == true){
    this.adBlockerEnabled = true;
   }

   if(this._svcService.getBusinessID() === "WF")
   {
    this.isWayfair=true;
   }
   
    this._contentService.getModuleContent()
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(data => data !== null && data !== undefined)
      )
      .subscribe((data) => {
        console.log("here==>");
        this._contentService.setModuleContent(data);
        this.moduleContent = (data.value) ? data.value.content.CARDS : data.content.CARDS;
        this.errormessage = '';
        this.updatePageMeta(this.moduleContent);
        this.isLoaded = true;
        this.isPrimaryContentDiffFromFlexSeo = this.dmar.primaryContentDiffFromFlexSeo();
        this.scPageData = {
          pageName: "sign_on"
        }
        if (isPlatformBrowser(this.platformId)) {
          this.scService.setSCPageData("load", this.scPageData);
        }
      });

    //this.isChannelFusion = this._svcService.isFusionChannel();
    this._hpTokenService.generatehoneyPotToken()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if (data !== null && data !== undefined) {
          this.XXXExtra = data;
        }
      });
    this._svcServices.scrollLocked
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.scrollLock = data;
      })

      console.log("this._contentService.getBrandingContent Call from signon Layout")
    this._contentService.getBrandingContent()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(data => {
        if (data !== null && data !== undefined) {
          this.branding = (data.value) ? data.value.content.CARDS : data.content.CARDS;
          let actionStr = 'cmlink$$link_go_to_partner_site_' + this.brandId;
        if (this.branding && this.branding[actionStr]) {
            this.branding.cmlink$$link_go_to_partner_site.LINK_TEXT = this.branding[actionStr].LINK_TEXT;
            if(this.branding.cmlink$$link_go_to_partner_site.URL && this.branding.cmlink$$link_go_to_partner_site.URL.FULL_URL && 
              this.branding[actionStr].URL && this.branding[actionStr].URL.FULL_URL)
             {
              this.branding.cmlink$$link_go_to_partner_site.URL.FULL_URL = this.branding[actionStr].URL.FULL_URL;
             }
            }

        this.ifBookmarkEnabled = (this.branding.copy$$bookmark_enabled) ? this.branding.copy$$bookmark_enabled.TEXT : false;
        }
       
      });

      this._contentService.getModalContent("jCARDS_svc_cw_modals")
      .subscribe((data) => {
      });  

      if (this._contentService?.pageContent?.content?.CARDS?.config$$cfg_cw_app_client_settings?.signon_angular_flexseo_disabled?.includes(this.siteId?.toUpperCase())) {
        this.isSignonFlexSeoDisable = true;
      } else{
        this.isSignonFlexSeoDisable = false;
      }
   

  }

  
  // TODO: write logic to populate layout based on user auth
  ngAfterViewInit() {
    this._contentService.componentLoaded.emit(true);

    // toggle ADA aria-hidden when popup content are opened and closed
    this.popupModalService.openPopupContent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.isHidden = true;
      });

    this.popupModalService.closePopupContent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.isHidden = false;
      });
  }

  getPrimaryContentDiffFromFlexSeo() {
    return this.isPrimaryContentDiffFromFlexSeo;
  }

  updatePageMeta(moduleContent) {
    if (moduleContent.copy$$signon_meta_title) {
      this.title.setTitle(this.parseSpecialCharacters(moduleContent.copy$$signon_meta_title.TEXT));
    }
    if (this.brandId){
      if (moduleContent['copy$$signon_meta_title_' + this.brandId] && moduleContent['copy$$signon_meta_title_' + this.brandId].TEXT) {
        this.title.setTitle(this.parseSpecialCharacters(moduleContent['copy$$signon_meta_title_' + this.brandId].TEXT))
      }
    }
    if (moduleContent.config$$rule_partner_catalog_contact_us && this.urlParameters && this.urlParameters.brandId) {
      moduleContent.config$$rule_partner_catalog_contact_us.catalogDetails = [];
      moduleContent.config$$rule_partner_catalog_contact_us.catalogDetails = moduleContent.config$$rule_partner_catalog_contact_us.ruleResponse.filter(e => e.includes('_'+ this.urlParameters.brandId.toUpperCase())); 
      if (!moduleContent.config$$rule_partner_catalog_contact_us.catalogDetails.length){
        moduleContent.config$$rule_partner_catalog_contact_us.catalogDetails =  moduleContent.config$$rule_partner_catalog_contact_us.ruleResponse;
      }
    }
    if (moduleContent.copy$$signon_meta_description) {
      this.meta.addTag({
        name: 'description',
        content: this.parseSpecialCharacters(moduleContent.copy$$signon_meta_description.TEXT)
      });
    }

  }
 
  parseSpecialCharacters(htmlString) {
    //Decodes special characters that are returned from CMS, ex: spanish accent letters

    let temp = this._renderer.createElement('textarea');
    temp.innerHTML = htmlString;
    return temp.value;
  }
  @HostListener("window:scroll") onscroll() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.ifBookmarkEnabled == "true") {
        var isIOS = /iPhone/i.test(this.windowService.nativeWindow.navigator.userAgent);
        if (isIOS && !(this.windowService.nativeWindow.navigator.standalone === true)) {
          if (this.windowService.nativeWindow.navigator.userAgent.indexOf('Safari') != -1 && this.windowService.nativeWindow.navigator.userAgent.indexOf('Chrome') == -1) {
            var st = this.windowService.nativeWindow.pageYOffset || this.windowService.nativeWindow.document.documentElement.scrollTop;
            if (st > this.lastScrollTop) {
              if (this.windowService.nativeWindow.document.body.scrollTop > 20 || this.windowService.nativeWindow.document.documentElement.scrollTop > 20) {
                if (this.scrollLock) {
                  this.popupModalService.openPopupContent.emit({
                    popupContentComponent: "popup-site-bookmark",
                    popupContentParams: ""
                  });
                }
              }
            } else {
              // upscroll code
            }
            this.lastScrollTop = st <= 0 ? 0 : st;
          }
        }
      }
    }
  }



}
